import { BIModel } from './BIModel';

export class ProductLikeBIModel extends BIModel {

  static eventName = 'product_like';

  #productId;
  #userIdOwner;
  #action;
  #flow;
  #isSeller;
  #location;
  #countrySeller;

  constructor(userId, productId, userIdOwner, action, flow, isSeller, location, countrySeller) {
    super(ProductLikeBIModel.eventName, userId);
    this.#productId = productId;
    this.#userIdOwner = userIdOwner;
    this.#action = action;
    this.#flow = flow;
    this.#isSeller = isSeller;
    this.#location = location;
    this.#countrySeller = countrySeller;
  }

  get productId() {
    return this.#productId;
  }

  get userIdOwner() {
    return this.#userIdOwner;
  }

  get action() {
    return this.#action;
  }

  get flow() {
    return this.#flow;
  }

  get isSeller() {
    return this.#isSeller;
  }

  get location() {
    return this.#location;
  }

  get countrySeller() {
    return this.#countrySeller;
  }

  get modelData() {
    return {
      product_id: this.productId,
      user_id_owner: this.userIdOwner,
      action: this.action,
      flow: this.flow,
      is_seller: this.isSeller,
      location: this.location,
      country_seller: this.countrySeller
    };
  }

}